/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_phred_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the difference between Phred+33 and Phred+64?`)
};

const es_phred_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre Phred+33 y Phred+64?`)
};

const de_phred_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen Phred+33 und Phred+64?`)
};

const nl_phred_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen Phred+33 en Phred+64?`)
};

const fr_phred_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre Phred+33 et Phred+64 ?`)
};

const it_phred_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra Phred+33 e Phred+64?`)
};

const pt_br2_phred_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual a diferença entre Phred+33 e Phred+64?`)
};

const pt_phred_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre Phred+33 e Phred+64?`)
};

const ja_phred_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred+33とPhred+64の違いは何ですか？`)
};

const zh_phred_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phred+33 和 Phred+64 有什么区别？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const phred_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.phred_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("phred_faq_q2", locale)
	if (locale === "en") return en_phred_faq_q2(inputs)
	if (locale === "es") return es_phred_faq_q2(inputs)
	if (locale === "de") return de_phred_faq_q2(inputs)
	if (locale === "nl") return nl_phred_faq_q2(inputs)
	if (locale === "fr") return fr_phred_faq_q2(inputs)
	if (locale === "it") return it_phred_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_phred_faq_q2(inputs)
	if (locale === "pt") return pt_phred_faq_q2(inputs)
	if (locale === "ja") return ja_phred_faq_q2(inputs)
	return zh_phred_faq_q2(inputs)
};